import { bl_ppl_einvoice_waiting_queue_RowClass } from '../../../dbschema/bl_ppl_einvoice_waiting_queue.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolEInvoiceWaitingQueueContainerModel extends BaseContainerModel {
    bl_ppl_einvoice_waiting_queue: bl_ppl_einvoice_waiting_queue_RowClass = new bl_ppl_einvoice_waiting_queue_RowClass();
}
